import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetCommentListById } from '@/Module/Comment/Model/ApiModel/IGetCommentListById';
import type { IComment } from '@/Module/Comment/Model/DataModel';
import commentService from '@/Module/Comment/Service/CommentService';
import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IState } from '@/Module/Store/Model';

export const commentGetListAction = createAsyncThunk<
  IGatewayResponse<IComment[]>,
  Omit<IGetCommentListById, 'PageNo' | 'PageSize' | 'childCount'>
>('comment/getList', (req, { getState, signal }) => {
  return commentService
    .getCommentListById(
      {
        ...req,
        childCount: 3,
        PageSize: (getState() as IState).comment.pageRows,
        PageNo: (getState() as IState).comment.page,
      },
      signal,
    )
    .then(({ data }) => {
      return data;
    });
});
